import { render, staticRenderFns } from "./initBookkeepingAction.vue?vue&type=template&id=278e7fea"
import script from "./initBookkeepingAction.vue?vue&type=script&lang=js"
export * from "./initBookkeepingAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports